import React, { useState, useEffect, useLayoutEffect } from "react";
import "./App.css";
import DigitalHuman from "@edhsdk/react-edh-js";

var callbacks;
var currStep, setCurrStep;
var cnt = null;
function MyDigitalHuman(token, newStep, id, persona) {
  [currStep, setCurrStep] = useState(null);
  console.log("Setting human with persona "+persona+" : ", newStep);
  if(!newStep[0].id) {
    console.log("Empty step, ignoring")
    //return;
  }
  let dummy = Object.assign({}, newStep);
  const handleCurrStepTrigger = (currStep, triggerStep, msg) => {
    console.log("Setting step: ", triggerStep);
    if (callbacks) {
      // This calls back into the Vue code!
      callbacks("Step taken: " + currStep);
    }
    setCurrStep(triggerStep);
  };
  if (id != cnt) {
    let oldid=id;
    cnt = id;
    setTimeout((oldid) => {
      console.log("Timer fired! " + oldid);
      cnt = oldid;
      setCurrStep(oldid);
    }, 100, oldid);
  }
  return (
    <>
      <DigitalHuman
        token={token}
        human={persona}
        steps={dummy}
        onCurrStepTrigger={handleCurrStepTrigger}
        currStep={currStep}
      />
    </>
  );
}
function DHApp(props) {
  console.log("Props: ", props);
  let persona = "s_m_f_01";
  if (props.doVue) {
    callbacks = props.doVue;
  } else {
    callbacks = null;
  }
  if(props.persona) {
    persona = props.persona;
    console.log("Setting persona: ",persona)
  }
  return MyDigitalHuman(props.token, props.steps, props.steps[0].id, persona);
}
export default DHApp;
